import { FunctionComponent, SVGProps } from 'react';

export type IconProps = {
  width?: number;
  height?: number;
  rotate?: number;
  className?: string;
};

const Icon = ({
  Svg,
  width,
  height,
  rotate,
  className,
  ...props
}: IconProps & {
  Svg: FunctionComponent<SVGProps<SVGSVGElement>>;
}) => {
  return (
    <Svg
      // Forwarded so styled(SomeIcon) can reach the SVG with its generated
      // class.
      className={className}
      data-selector="icon-svg"
      focusable={false}
      width={width || 16}
      height={height || 16}
      style={
        rotate
          ? {
              transform: `rotate(${rotate}deg)`,
            }
          : {}
      }
      {...props}
    />
  );
};

export default Icon;
